import React, { useMemo } from "react";
import TestimonialCard from "./TestimonialCard";

function Testimonials() {
  const testimonials = useMemo(() => [
    {
      name: "Sarah Thompson",
      role: "Real Estate Agent",
      content:
        "I used to spend hours scrolling through social media looking for potential leads. Now, with this tool, I can identify and connect with qualified prospects in minutes. It's a game-changer for my business.",
      avatar: "https://randomuser.me/api/portraits/women/1.jpg",
    },
    {
      name: "Jane Smith",
      role: "Real Estate Agent",
      content: "Love the automated lead nurturing features. It's like having a personal assistant that never sleeps!",
      avatar: "https://randomuser.me/api/portraits/women/4.jpg",
    },
    {
      name: "David Kim",
      role: "Real Estate Agent",
      content:
        "The automated lead generation feature has significantly increased my productivity. I'm able to follow up with more leads and close deals faster than ever before.",
      avatar: "https://randomuser.me/api/portraits/men/2.jpg",
    },
    {
      name: "Emily Davis",
      role: "Real Estate Agent",
      content: "User-friendly interface and great support. The team is always there to help when needed.",
      avatar: "https://randomuser.me/api/portraits/women/5.jpg",
    },
    {
      name: "John Doe",
      role: "Real Estate Agent",
      content: "LeadTrek has boosted my leads significantly. The ROI is incredible!",
      avatar: "https://randomuser.me/api/portraits/men/3.jpg",
    },
    {
      name: "Michael Johnson",
      role: "Real Estate Agent",
      content:
        "LeadTrek streamlined my lead gen, so I can focus on building relationships. The analytics help me make informed decisions.",
      avatar: "https://randomuser.me/api/portraits/men/6.jpg",
    },
  ], []);

  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black/80" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#C334F6]/5 to-[#543DF4]/5" />
      
      {/* Decorative Elements */}
      <div className="absolute -top-20 -right-20 w-80 h-80 bg-[#C334F6]/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-[#543DF4]/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-block px-6 py-2 rounded-full border border-white/20 bg-white/10 backdrop-blur-sm mb-6 text-white/90 font-medium tracking-wide">
            Testimonials
          </span>
          <h2 className="text-4xl md:text-5xl font-normal leading-[1.2] tracking-[0.001em] mb-6 text-white/95">
            Discover how our tool has helped our lovely
            <br />
            <span className="bg-gradient-to-r from-[#C334F6] to-[#543DF4] bg-clip-text text-transparent">
              clients to achieve their goals
            </span>
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto text-lg">
            Join thousands of satisfied real estate agents who have transformed their lead generation process
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} {...testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default React.memo(Testimonials);
